<script lang="ts">
	import * as Resizable from '@ui-components/ui/resizable/index';
	import { cn } from '@ui-lib/utils/utils';
	import * as ResizablePrimitive from 'paneforge';
	import { setContext } from 'svelte';
	let appliedLayout: number[] | null = null;
	interface Props {
		paneGroupApi?: ResizablePrimitive.PaneGroupAPI;
		ref?: HTMLDivElement | null;
		isVisible?: boolean;
		title?: string;
		direction?: ResizablePrimitive.PaneGroupProps['direction'];
		class?: string;
		children?: import('svelte').Snippet;
	}

	let {
		paneGroupApi = $bindable(undefined),
		ref = $bindable(undefined),
		isVisible = false,
		title = 'Meeting Notes',
		direction = 'horizontal',
		class: className = '',
		children
	}: Props = $props();

	// Default left pane width to ~30%, clamped between 15 and 85
	let leftPanePercentage = $derived(Math.min(85, Math.max(15, 30)));
	let rightPanePercentage = $derived(Math.min(85, Math.max(15, 100 - leftPanePercentage)));

	$effect(() => {
		if (!paneGroupApi) {
			appliedLayout = null;
			return;
		}

		if (leftPanePercentage <= 0 || rightPanePercentage <= 0) {
			return;
		}

		const nextLayout: number[] = [leftPanePercentage, rightPanePercentage];

		if (
			appliedLayout &&
			appliedLayout.length === nextLayout.length &&
			appliedLayout.every((value, index) => value === nextLayout[index])
		) {
			return;
		}

		const currentLayout = paneGroupApi.getLayout?.();
		if (
			currentLayout &&
			currentLayout.length === nextLayout.length &&
			currentLayout.every((value, index) => value === nextLayout[index])
		) {
			appliedLayout = [...currentLayout];
			return;
		}

		paneGroupApi.setLayout(nextLayout);
		appliedLayout = [...nextLayout];
	});

	setContext('asSheet', false);
</script>

<Resizable.PaneGroup
	bind:paneGroup={paneGroupApi}
	bind:ref
	{direction}
	class={cn(
		'dark:outline-b-600 min-h-0 flex-1 flex-grow select-none flex-row overflow-hidden pb-0 pr-2',
		isVisible ? 'flex' : '!hidden',
		className
	)}
	style="max-width: 100vw;"
>
	{@render children?.()}
</Resizable.PaneGroup>
<!-- 
dark:bg-b-800/50 
bg-white/50 
 md:rounded-2xl
  outline outline-[0.50px] outline-offset-[-0.50px] outline-white

-->
